import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoginService } from '@bmng/services/login.service';
import { UsersService } from '@bmng/services/users/users.service';
import { catchError, map } from 'rxjs/operators';


export const loginGuardServiceCanActivate: ResolveFn<boolean> =
    () => {
        const usersService = inject(UsersService);
        const loginService = inject(LoginService);

        return usersService.getUserSettingsFromOldBm()
            .pipe(
                map((data) => !!data),
                catchError(err => loginService.catchUnauthenticatedUserFromLoginGuard(err)),
            );
    };
